import { render, staticRenderFns } from "./preExample.vue?vue&type=template&id=f35deed4&scoped=true"
import script from "./preExample.vue?vue&type=script&lang=js"
export * from "./preExample.vue?vue&type=script&lang=js"
import style0 from "./preExample.vue?vue&type=style&index=0&id=f35deed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35deed4",
  null
  
)

export default component.exports